// Vanderbilt University's undergraduate majors (#2652). Read on 2026-10-01
// from Undergraduate Admissions' Find Your Major page, which says "All our
// bachelor's degree majors are listed below" and showed 70 with the
// Bachelors filter; each major's school comes from the same page's data (the
// program finder feed it loads), with the Graduate School and School of
// Medicine tags dropped. Checked against the College of Arts and Science's
// Majors and Minors page: every A&S major there is in this list. The page
// does not name the degree, so `degree` is null. Names are the page's own,
// including "AI Design and Practice" (College of Connected Computing) and
// "Special Education (B.S.)". Minors, graduate programs and concentrations
// are left out. The KB's majors list was the starting point; the official
// list wins.
const majors = {
    "slug": "vanderbilt-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major on Vanderbilt's official Find Your Major list, grouped by the school that offers it. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Blair School of Music",
            "source": {
                "label": "Vanderbilt Undergraduate Admissions, Find Your Major",
                "url": "https://admissions.vanderbilt.edu/major/"
            },
            "majors": [
                {
                    "name": "Jazz Studies",
                    "degree": null
                },
                {
                    "name": "Music Composition",
                    "degree": null
                },
                {
                    "name": "Music Education (Blair-to-Peabody)",
                    "degree": null
                },
                {
                    "name": "Music Integrated Studies",
                    "degree": null
                },
                {
                    "name": "Music Performance",
                    "degree": null
                },
                {
                    "name": "Musical Arts",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Arts and Science",
            "source": {
                "label": "Vanderbilt Undergraduate Admissions, Find Your Major",
                "url": "https://admissions.vanderbilt.edu/major/"
            },
            "majors": [
                {
                    "name": "African American and Diaspora Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Architecture and the Built Environment",
                    "degree": null
                },
                {
                    "name": "Art",
                    "degree": null
                },
                {
                    "name": "Asian American and Asian Diaspora Studies",
                    "degree": null
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Biochemistry and Chemical Biology",
                    "degree": null
                },
                {
                    "name": "Biological Sciences",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Cinema and Media Arts",
                    "degree": null
                },
                {
                    "name": "Classical and Mediterranean Studies",
                    "degree": null
                },
                {
                    "name": "Climate and Environmental Studies",
                    "degree": null
                },
                {
                    "name": "Communication of Science and Technology",
                    "degree": null
                },
                {
                    "name": "Communication Studies",
                    "degree": null
                },
                {
                    "name": "Culture, Advocacy, and Leadership",
                    "degree": null
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Economics and History",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "European Studies",
                    "degree": null
                },
                {
                    "name": "French",
                    "degree": null
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "History of Art",
                    "degree": null
                },
                {
                    "name": "Integrative Biology",
                    "degree": null
                },
                {
                    "name": "Jewish Studies",
                    "degree": null
                },
                {
                    "name": "Latin American, Caribbean, and Latinx Studies",
                    "degree": null
                },
                {
                    "name": "Law, History, and Society",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Medicine, Health, and Society",
                    "degree": null
                },
                {
                    "name": "Molecular and Cellular Biology",
                    "degree": null
                },
                {
                    "name": "National Security",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Public Policy Studies",
                    "degree": null
                },
                {
                    "name": "Religious Studies",
                    "degree": null
                },
                {
                    "name": "Romance Languages, Cultures, and Diasporas",
                    "degree": null
                },
                {
                    "name": "Russian Studies",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Spanish and Portuguese",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Connected Computing",
            "source": {
                "label": "Vanderbilt Undergraduate Admissions, Find Your Major",
                "url": "https://admissions.vanderbilt.edu/major/"
            },
            "majors": [
                {
                    "name": "AI Design and Practice",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                }
            ]
        },
        {
            "name": "Peabody College of Education and Human Development",
            "source": {
                "label": "Vanderbilt Undergraduate Admissions, Find Your Major",
                "url": "https://admissions.vanderbilt.edu/major/"
            },
            "majors": [
                {
                    "name": "Child Development",
                    "degree": null
                },
                {
                    "name": "Child Studies",
                    "degree": null
                },
                {
                    "name": "Cognitive Studies",
                    "degree": null
                },
                {
                    "name": "Elementary Education",
                    "degree": null
                },
                {
                    "name": "Human and Organizational Development",
                    "degree": null
                },
                {
                    "name": "Language Sciences",
                    "degree": null
                },
                {
                    "name": "Secondary Education",
                    "degree": null
                },
                {
                    "name": "Special Education (B.S.)",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Engineering",
            "source": {
                "label": "Vanderbilt Undergraduate Admissions, Find Your Major",
                "url": "https://admissions.vanderbilt.edu/major/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Engineering Science",
                    "degree": null
                },
                {
                    "name": "Environmental Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
